import { render, staticRenderFns } from "./Home.sync-postback.vue?vue&type=template&id=1dc00d10&scoped=true&"
import script from "./Home.sync-postback.vue?vue&type=script&lang=js&"
export * from "./Home.sync-postback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc00d10",
  null
  
)

export default component.exports